import { OFFLINE_MODE_ENABLED } from '@/services/offline/offlineFeature'

export const DEFAULT_WAITER_TPV_PERMISSIONS = [
  'punto-venta',
  'comandas',
  'carta-stock',
  'control-horario',
  'caja'
]

export const EWU_APP_TPV_PERMISSIONS = [
  'comandas',
  'salones',
  'carta-stock',
  'carta-basica',
  'dashboard',
  'inteligencia-artificial',
  'fidelizacion',
  'ajustes',
  'sincronizacion-local',
  'historial-pedidos',
  'personal'
]

export const TPV_MENU_ITEMS = [
  {
    id: 'punto-venta',
    title: 'Punto de Venta',
    subtitle: 'Gestiona ventas y pedidos',
    icon: 'fa-solid fa-cash-register',
    route: '/PuntoDeVenta',
    dockLabel: 'Ventas'
  },
  {
    id: 'comandas',
    title: 'Comandas',
    subtitle: 'Gestión de comandas',
    icon: 'fa-solid fa-list-check',
    route: '/PanelComandas',
    dockLabel: 'Comandas'
  },
  {
    id: 'salones',
    title: 'Gestión de Salones',
    subtitle: 'Mapa de salas y mesas',
    icon: 'fa-solid fa-door-open',
    route: '/GestionMesas',
    dockLabel: 'Salones'
  },
  {
    id: 'carta-stock',
    title: 'Carta / Stock',
    subtitle: 'Productos e inventario',
    icon: 'fa-solid fa-utensils',
    route: '/GestionCarta',
    dockLabel: 'Carta'
  },
  {
    // Acceso reducido a la carta: solo activar y desactivar platos. Se concede desde
    // la opción Carta / Stock de Personal, no como un acceso suelto.
    id: 'carta-basica',
    title: 'Carta',
    subtitle: 'Activa y desactiva platos',
    icon: 'fa-solid fa-toggle-on',
    route: '/CartaRapida',
    dockLabel: 'Carta',
    accessLabel: 'Carta (solo activar platos)',
    accessVariantOf: 'carta-stock'
  },
  {
    id: 'dashboard',
    title: 'Dashboard',
    subtitle: 'Estadísticas y reportes',
    icon: 'fa-solid fa-chart-pie',
    route: '/DashboardPartner',
    dockLabel: 'Dashboard'
  },
  {
    id: 'inteligencia-artificial',
    title: 'Inteligencia artificial',
    subtitle: 'Funciones y consumo de IA',
    icon: 'fa-solid fa-wand-magic-sparkles',
    route: '/InteligenciaArtificial',
    dockLabel: 'IA',
    partnerOnly: true
  },
  {
    id: 'fidelizacion',
    title: 'Fidelización',
    subtitle: 'Programas de lealtad',
    icon: 'fa-solid fa-gift',
    route: '/Fidelizacion',
    dockLabel: 'Fidelización'
  },
  {
    id: 'ajustes',
    title: 'Ajustes',
    subtitle: 'Configuración del sistema',
    icon: 'fa-solid fa-gear',
    route: '/PartnerSettings',
    dockLabel: 'Ajustes'
  },
  {
    id: 'sincronizacion-local',
    title: 'Sincronización local',
    subtitle: 'Estado, copia local y recuperación',
    icon: 'fa-solid fa-arrows-rotate',
    route: '/SincronizacionLocal',
    dockLabel: 'Sync local',
    alwaysVisible: true
  },
  {
    id: 'control-horario',
    title: 'Control Horario',
    subtitle: 'Registro de jornadas',
    icon: 'fa-solid fa-clock',
    route: '/ControlHorario',
    dockLabel: 'Control Horario'
  },
  {
    id: 'reservas',
    title: 'Reservas',
    subtitle: 'Gestión de reservas',
    icon: 'fa-solid fa-calendar-check',
    route: '/ReservasPartner',
    dockLabel: 'Reservas'
  },
  {
    id: 'historial-pedidos',
    title: 'Historial de pedidos',
    subtitle: 'Pedidos por servicio y mesa',
    icon: 'fa-solid fa-clock-rotate-left',
    route: '/HistorialPedidos',
    dockLabel: 'Historial'
  },
  {
    id: 'caja',
    title: 'Caja',
    subtitle: 'Arqueos y movimientos',
    icon: 'fa-solid fa-money-bill-wave',
    route: '/CajaPartner',
    dockLabel: 'Caja'
  },
  {
    id: 'personal',
    title: 'Personal',
    subtitle: 'Gestión de empleados',
    icon: 'fa-solid fa-users',
    route: '/GestionCamareros',
    dockLabel: 'Personal'
  },
  {
    id: 'facturas',
    title: 'Facturas',
    subtitle: 'Facturación y documentos',
    icon: 'fa-solid fa-file-invoice-dollar',
    route: '/FacturasPartner',
    dockLabel: 'Facturas'
  },
  {
    id: 'clientes-habituales',
    title: 'Clientes habituales',
    subtitle: 'Clientes frecuentes y empresas',
    icon: 'fa-solid fa-address-book',
    route: '/ClientesHabituales',
    dockLabel: 'Clientes'
  },
].filter((item) => OFFLINE_MODE_ENABLED || item.id !== 'sincronizacion-local')

export const TPV_ROUTE_PERMISSION_BY_PATH = {
  '/PuntoDeVenta': 'punto-venta',
  '/PanelComandas': 'comandas',
  '/PanelMesas': 'salones',
  '/GestionMesas': 'salones',
  '/GestionCarta': 'carta-stock',
  '/CartaRapida': 'carta-basica',
  '/DashboardPartner': 'dashboard',
  '/InteligenciaArtificial': 'inteligencia-artificial',
  '/Fidelizacion': 'fidelizacion',
  '/ControlHorario': 'control-horario',
  '/ReservasPartner': 'reservas',
  '/ReservasConfig': 'reservas',
  '/HistorialPedidos': 'historial-pedidos',
  '/PartnerSettings': 'ajustes',
  '/SincronizacionLocal': 'sincronizacion-local',
  '/CajaPartner': 'caja',
  '/GestionCamareros': 'personal',
  '/FacturasPartner': 'facturas',
  '/ClientesHabituales': 'clientes-habituales'
}

export function normalizeTpvPermissions(permissions, fallback = DEFAULT_WAITER_TPV_PERMISSIONS) {
  if (!Array.isArray(permissions)) {
    return [...fallback]
  }

  const validIds = new Set(TPV_MENU_ITEMS.map((item) => item.id))
  const normalized = permissions.filter((permission) => validIds.has(permission))
  // El acceso completo a la carta incluye el reducido: nunca conviven.
  if (normalized.includes('carta-stock')) {
    return normalized.filter((permission) => permission !== 'carta-basica')
  }
  return normalized
}

export function canAccessTpvPermission(user, permission) {
  if (!permission) return true
  if (!user) return false
  if (permission === 'inteligencia-artificial' && !user.is_partner) return false
  if (user?.subscription_plan === 'ewu_app' && !EWU_APP_TPV_PERMISSIONS.includes(permission)) {
    return false
  }
  // El modo reducido de carta solo existe para quien no tiene la carta completa.
  if (permission === 'carta-basica' && user?.is_partner) return false
  if (user?.is_partner) return true

  return normalizeTpvPermissions(user?.tpv_permissions).includes(permission)
}

export function getAvailableTpvMenuItems(user) {
  return TPV_MENU_ITEMS.filter((item) => canAccessTpvPermission(user, item.id))
}

export function getTpvPermissionForPath(path) {
  return TPV_ROUTE_PERMISSION_BY_PATH[path] || null
}
